<template>
  <div>
    <van-nav-bar title="用药兑水计算" fixed left-arrow @click-left="onClickLeft" />
    <div class="PotionCalculation">
      <div class="btn-group wh-flex-between">
        <div :class="{activeBtn: tabShow}" class="btn-item" @click="tabOneClick">
          用药量计算
        </div>
        <div :class="{activeBtn: !tabShow}" class="btn-item" @click="tabTwoClick">
          兑水量计算
        </div>
      </div>
      <van-cell-group class="input-field">
        <van-field v-model.trim="multiple" label="稀释倍数(倍)" placeholder="点击输入稀释的倍数" input-align="right" />
        <van-field v-show="tabShow" v-model.trim="water" label="兑水量(斤)" placeholder="点击输入兑水量" input-align="right" />
        <van-field v-show="!tabShow" v-model.trim="drug" label="用药量(ml或g)" placeholder="点击输入用药量" input-align="right" />
      </van-cell-group>
      <van-cell-group v-show="result">
        <van-cell :title="tabShow ? '用药量(ml/g)' : '兑水量(斤)'">
          <template #default>
            <span class="use-result">{{ result }}</span>
          </template>
        </van-cell>
      </van-cell-group>
      <div class="count-btn" @click="handleComputed">
        计算
      </div>
      <div class="count-tips">
        <p>温馨提示:</p>
        <ul>
          <li>· 稀释倍数:可在药肥包装上查找,或咨询专业人士</li>
          <li v-show="tabShow">
            · 兑水量:可根据实际用药面基来确定兑水量
          </li>
          <li v-show="!tabShow">
            · 用药量:可填写您本次的用药量
          </li>
          <li>· 计算结果为业内经验所得,结果仅供参考</li>
        </ul>
      </div>
      <div class="tableInfo">
        <van-divider>您还可以通过以下表格快速查找</van-divider>
        <table class="table1">
          <tr>
            <th colspan="2" rowspan="2" class="table-th">
              用药量(毫升或克)
            </th>
            <th colspan="5" style="text-align: left; background:#ffc8ce;">
              兑水量(斤)
            </th>
          </tr>
          <tr>
            <td rowspan="19" colspan="5" style="padding: 0; position: relative">
              <div class="list">
                <table class="table2">
                  <tr style="background:#ffc8ce;font-weight: bold;">
                    <td v-for="(item, index) in calculationArr[0]" :key="index">
                      <div>{{ item }}斤</div>
                    </td>
                  </tr>
                  <tr v-for="(item, index) in getCalcList" :key="index">
                    <td v-for="(item2, index2) in item" :key="index2">
                      <div>{{ item2 }}</div>
                    </td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <th rowspan="18" colspan="1">
              稀释倍数
            </th>
            <th>100倍</th>
          </tr>
          <template v-for="(item, index) in calculationArr[1]">
            <tr v-if="index > 0" :key="index">
              <th>
                {{ item }}倍
              </th>
            </tr>
          </template>
          <tr style="background: #bebebe;">
            <td colspan="7">
              上表前提是,液体药剂的密度为1,固体药剂忽略体积换算
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { calculationArr } from '@/utils/fixedData'
export default {
  name: 'PotionCalculation',
  data() {
    return {
      tabShow: true,
      result: '',
      multiple: '',
      water: '',
      drug: '',
      calculationArr
    }
  },
  computed: {
    getCalcList() {
      const calcList = []
      calculationArr[1].forEach(item => {
        const tempArr = []
        calculationArr[0].forEach(item2 => {
          tempArr.push((item2 * 500 / item).toFixed(1))
        })
        calcList.push(tempArr)
      })
      return calcList
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    backFn() {
      window.history.go(-1)
    },
    tabOneClick() {
      this.tabShow = true
      this.resetComputed()
    },
    tabTwoClick() {
      this.tabShow = false
      this.resetComputed()
    },
    resetComputed() {
      this.result = ''
      this.multiple = ''
      this.water = ''
      this.drug = ''
    },
    handleComputed() {
      if (this.tabShow) {
        if (!this.water || !this.multiple) {
          // Toast('输入不能为空')
          return
        }
        this.result = ((parseFloat(this.water) * 500) / parseFloat(this.multiple)).toFixed(1)
      } else {
        if (!this.drug || !this.multiple) {
          // Toast('输入不能为空')
          return
        }
        this.result = ((parseFloat(this.multiple) * parseFloat(this.drug)) / 500).toFixed(1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.PotionCalculation{
  padding-top: 30px;
  .btn-group{
    padding: 40px 30px;
    .btn-item{
      font-size: 14px;
      flex: 1;
      border: 1px solid #31d181;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #31d181;
      &:first-child{
        border-top-left-radius: 18px;
        border-bottom-left-radius: 18px;
      }
       &:last-child{
        border-top-right-radius:  18px;
        border-bottom-right-radius: 18px;
      }
    }
       .activeBtn{
      background: #31d181;
      color: #fff;
    }
  }
  .input-field{
    /deep/.van-field__label{
      width: 120px;
    }
    /deep/.van-field__body input{
      font-size: 16px;
      font-weight: bold;
      color: #222;
      &::placeholder {
          font-size: 14px;
          color: #888;
         font-weight: 400;
      }
    }
  }
  .use-result{
    font-size: 18px;
    color: #31d181;
  }
  .count-btn{
    color: #fff;
    width: 60%;
    height: 40px;
    line-height: 40px;
    background-color: #31d181;
    border-radius: 8px;
    text-align: center;
    font-size: 14px;
    margin: 30px auto 30px;
  }
  .count-tips{
    font-size: 12px;
    color: #777;
    padding: 10px 16px;
  }
  .tableInfo{
    margin-top: 20px;
    padding: 20px 5px 50px;
    background: #fff;
    box-sizing: border-box;
    p {
      color: #333;
    }
     .table1,
    .table1 tr th,
    .table1 tr td {
      border:1px solid #333;
      border-collapse: collapse;
      padding: 0 5px;
      height: 20px;
    }
     .table1 .table-th{
      background:#fdea9b;
      height: 40px;
      width: 120px;
    }
    .table1 {
      table-layout: fixed;
      width: 100%;
      margin: 0 auto;
      font-size: 12px;
      tr {
        background: #c6efcd;
      }
    }
    .list {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: #ccc;
      overflow-x: scroll;
      overflow-y: hidden;
      .table2 {
        text-align: center;
        font-size: 12px;
        width: 600px;
        border-collapse: collapse;
        border: none;
        tr, th, td {
          border: none;
          padding: 0;
          height: 20px;
        }
        tr {
          height: 20px;
          th{
            height: 100%;
            border-right: 1px solid #000;
          }
          th:last-child div,
          td:last-child div {
            border-right: none;
          }
          td {
            border-right: 1px solid #000;
          }
          &:last-child div {
            border-bottom: none;
          }
          &:nth-child(n) {
            background: #fbd546;
            border-bottom: 1px solid #000;
          }
          &:nth-child(2n) {
            background: #ffeb9c;
          }
        }
        tr:first-child, tr:first-child th,  tr:first-child td{
          height: 19.5px;
        }
      }
    }
  }
}

  // .tableInfo {
  //   margin-top: 20px;
  //   padding: 20px 5px 50px;
  //   background: #fff;
  //   box-sizing: border-box;
  //   p {
  //     color: #333;
  //   }
  //   .table1,
  //   .table1 tr th,
  //   .table1 tr td {
  //     border:1px solid #333;
  //     border-collapse: collapse;
  //     padding: 0 px2rem(5);
  //     height: 20px;
  //   }
  //   .table1 .table-th{
  //     background:#fdea9b;
  //     height: 40px;
  //     width: 120px;
  //   }
  //   .table1 {
  //     table-layout: fixed;
  //     width: 100%;
  //     margin: 0 auto;
  //     font-size: 12px;
  //     tr {
  //       background: #c6efcd;
  //     }
  //   }
  //   .list {
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     bottom: 0;
  //     right: 0;
  //     background: #ccc;
  //     overflow-x: scroll;
  //     overflow-y: hidden;
  //     .table2 {
  //       text-align: center;
  //       font-size: 12px;
  //       width: 600px;
  //       border-collapse: collapse;
  //       border: none;
  //       tr, th, td {
  //         border: none;
  //         padding: 0;
  //         height: 20px;
  //       }
  //       tr {
  //         height: 20px;
  //         th{
  //           height: 100%;
  //           border-right: 1px solid #000;
  //         }
  //         th:last-child div,
  //         td:last-child div {
  //           border-right: none;
  //         }
  //         td {
  //           border-right: 1px solid #000;
  //         }
  //         &:last-child div {
  //           border-bottom: none;
  //         }
  //         &:nth-child(n) {
  //           background: #fbd546;
  //           border-bottom: 1px solid #000;
  //         }
  //         &:nth-child(2n) {
  //           background: #ffeb9c;
  //         }
  //       }
  //       tr:first-child, tr:first-child th,  tr:first-child td{
  //         height: 19.5px;
  //       }
  //     }
  //   }
  // }

</style>
